import React from "react";

import "./perfilFamili.css";


export const PerfilFami = ({ nombre, imagen, onClick }) => {
    return (
        <div className="CuadroPerfilFami" onClick={onClick}>
            <img
                src={imagen || "/front/src/img/imgPerfil.webp"} // Usa la imagen predeterminada si no hay imagen
                alt={nombre}
                className="imgPerfilFami"
                onError={(e) => {
                    e.target.src = "/front/src/img/imgPerfil.webp"; // Imagen predeterminada si falla la carga
                }}
            />

            <h4>{nombre}</h4>
        </div>
    );
};